import { useSelector } from "react-redux";
import type { RootState } from "@/types/RootState";

const AiDisclaimer = () => {
  const language = useSelector((state: RootState) => state.language);

  return (
    <div className="alert alert-light border-0 bg-light">
      <small className="text-muted">
        <strong>{language.ai_disclaimer_key}</strong>
      </small>
    </div>
  );
};

export default AiDisclaimer;
